<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card elevation="0" class="rounded-lg primary--text">
          <v-row class="text-start" align="center">
            <v-col cols="auto">
              <div class="ps-6 font-weight-medium text-subtitle-2" style="width: 72px">
                {{ $t("organization.logo") }}
              </div>
            </v-col>

            <v-col cols="auto">
              <div class="font-weight-medium text-subtitle-2" style="width: 100px">{{ $t("organization.orgId") }}</div>
            </v-col>

            <v-col cols>
              <div class="font-weight-medium text-subtitle-2">{{ $t("organization.organization") }}</div>
            </v-col>

            <v-col cols="2" class="text-center">
              <div class="font-weight-medium text-subtitle-2">{{ $t("statistics.totalEmployees") }}</div>
            </v-col>

            <v-col cols="auto">
              <div class="font-weight-medium text-subtitle-2 pe-md-3 text-right" style="width: 151px">Actions</div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-row v-if="loading && !data.length">
          <v-col cols="12">
            <v-progress-circular indeterminate color="primary">
            </v-progress-circular>
          </v-col>
        </v-row>

        <v-row v-else-if="!loading && data.length">
          <v-col cols="12" v-for="(organization, index) in data" :key="index">
            <organization-card
              :organization="organization"
              @editOrganization="edit"
              @deleteOrganization="removeOrganization"
              @updateErr="onError('update')"
            />
          </v-col>
        </v-row>

        <v-row
          v-else-if="!loading && !data.length"
          class="textLight--text font-weight-medium"
          align="center"
        >
          <v-col cols="12">
            {{ $t("noItems") }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OrganizationCard from "./OrganizationCard.vue";
import { deleteOrganization } from "../methods/deleteOrganization";

export default {
  components: {
    OrganizationCard,
  },
  props: {
    data: {
      type: Array,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    removeOrganization(id) {
      const msg =
        this.$i18n.locale === "ar"
          ? "سيتم حذف هذه المنظمة بيرمابلطف. هل أنت متأكد من الاستمرار؟"
          : "This organization will be deleted permanently. Are you sure to continue?";

      this.$dialog
        .confirm(msg)
        .then(() => {
          deleteOrganization(id).then(res => {
            if (res.data) this.$emit("reFetch");
            if (res.error) {
              this.onError("delete");
            }
          });
        })
        .catch(_ => {});
    },
    onError(type) {
      let msg = null;
      if (type === "delete") {
        msg = this.$t("deleteFailed");
      }
      if (type === "update") {
        msg = this.$t("updateFailed");
      }
      this.$emit("responseErr", msg);
    },
    edit(val) {
      if (val) {
        this.$emit("editOrganizationVal", val);
      }
    },
  },
};
</script>
